import React from 'react'
import { DeliveryWindowInput } from './DeliveryWindowInput'

export const DeliveryWindowSetting = (props) => (
  <React.Fragment>
    <h3>Delivery Window</h3>
    <p>Set a delivery window that suits your audience</p>
    <DeliveryWindowInput {...props} />
  </React.Fragment>
)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/DeliveryWindowSetting.js